const UitkLayoutFlexDirectionMap = [
  ["row", "flex-direction-row"],
  ["row-reverse", "flex-direction-row-reverse"],
  ["column", "flex-direction-column"],
  ["column-reverse", "flex-direction-column-reverse"]
];
export const UitkLayoutFlexDirections = new Map(UitkLayoutFlexDirectionMap);
const UitkLayoutFlexWrapMap = [
  ["nowrap", "flex-wrap-nowrap"],
  ["wrap", "flex-wrap-wrap"],
  ["wrap-reverse", "flex-wrap-wrap-reverse"]
];
export const UitkLayoutFlexWraps = new Map(UitkLayoutFlexWrapMap);
const UitkLayoutFlexAlignContentMap = [
  ["center", "align-content-center"],
  ["end", "align-content-flex-end"],
  ["start", "align-content-flex-start"],
  ["space-around", "align-content-space-around"],
  ["space-between", "align-content-space-between"],
  ["space-evenly", "align-content-space-evenly"]
];
export const UitkLayoutFlexAlignContents = new Map(UitkLayoutFlexAlignContentMap);
const UitkLayoutFlexJustifyContentMap = [
  ["center", "justify-content-center"],
  ["end", "justify-content-flex-end"],
  ["start", "justify-content-flex-start"],
  ["space-around", "justify-content-space-around"],
  ["space-between", "justify-content-space-between"],
  ["space-evenly", "justify-content-space-evenly"]
];
export const UitkLayoutFlexJustifyContents = new Map(UitkLayoutFlexJustifyContentMap);
const UitkLayoutFlexAlignItemsMap = [
  ["center", "align-items-center"],
  ["end", "align-items-flex-end"],
  ["start", "align-items-flex-start"],
  ["stretch", "align-items-stretch"]
];
export const UitkLayoutFlexAlignItems = new Map(UitkLayoutFlexAlignItemsMap);
const UitkLayoutFlexItemGrowMap = [
  [0, "flex-grow-0"],
  [1, "flex-grow-1"],
  [2, "flex-grow-2"],
  [3, "flex-grow-3"],
  [4, "flex-grow-4"],
  [5, "flex-grow-5"],
  [6, "flex-grow-6"],
  [7, "flex-grow-7"],
  [8, "flex-grow-8"],
  [9, "flex-grow-9"],
  [10, "flex-grow-10"]
];
export const UitkLayoutFlexItemGrows = new Map(UitkLayoutFlexItemGrowMap);
const UitkLayoutFlexItemShrinkMap = [
  [0, "flex-shrink-0"],
  [1, "flex-shrink-1"]
];
export const UitkLayoutFlexItemShrinks = new Map(UitkLayoutFlexItemShrinkMap);
const UitkLayoutFlexItemAlignSelfMap = [
  ["center", "align-self-center"],
  ["end", "align-self-flex-end"],
  ["start", "align-self-flex-start"],
  ["stretch", "align-self-stretch"]
];
export const UitkLayoutFlexItemAlignSelfs = new Map(UitkLayoutFlexItemAlignSelfMap);
const UitkLayoutFlexBlockSizeMap = [["full_size", "block-size-full-size"]];
export const UitkLayoutFlexBlockSizes = new Map(UitkLayoutFlexBlockSizeMap);
